import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import { useSelector } from 'store/hooks';
import DonutCard from 'components/DashboardComponents/DashboardGraphs/DonutChartDashboard';
import DashboardListTable from 'components/DashboardComponents/DashboardListTable/DashboardListTable';
import PendingAtBarChart from 'components/DashboardComponents/DashboardGraphs/PendingAtBarChart';
import KpiMetricsTable from './KpiMetricsTable/KpiMetricsTable';
import AverageGradeCard from 'components/DashboardComponents/DashboardListTable/AverageGradeCard';

const KpiMetricsPerformance = ({
  donutDataClient,
  COLORS_CONSULTANT,
  COLORS_DM,
  COLORS_CLIENT,
  barChartData,
  metric,
  data_table,
  onDownloadXlsx,
  showDownload,
}) => {
  const { loadings } = useSelector((state) => state);
  const workFlowLabels = [
    { labelname: 'A', color: '#60C39B', dataKey: 'ratingA', toolbarText: 'ratingARaw' },
    { labelname: 'B', color: '#3C83F0', dataKey: 'ratingB', toolbarText: 'ratingBRaw' },
    { labelname: 'C', color: '#FFD200', dataKey: 'ratingC', toolbarText: 'ratingCRaw' },
    { labelname: 'D', color: '#FF9100', dataKey: 'ratingD', toolbarText: 'ratingDRaw' },
    { labelname: 'E', color: '#808080', dataKey: 'ratingE', toolbarText: 'ratingERaw' },
    { labelname: 'S', color: '#E600E6', dataKey: 'ratingS', toolbarText: 'ratingSRaw' },
    // { labelname: 'To be Done', color: '#C0C0C0', dataKey: 'rating99', toolbarText: 'rating99Raw' },
  ];

  return (
    <>
      {/* Donut Chart Row */}
      <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
        {[
          // { title: 'Consultant Submission', data: donutDataConsultant, colors: COLORS_CONSULTANT },
          // { title: 'DM Validation', data: donutDataDM, colors: COLORS_DM },
          { title: 'Rating', data: donutDataClient, colors: COLORS_CLIENT },
        ].map((item) => (
          //         <Grid container spacing={2}>
          // {items.map((item) => (
          <React.Fragment key={item.title}>
            {/* 1. Donut Chart Card */}
            <Grid item xs={12} sm={6} md={4} key={item.title}>
              <Paper
                sx={{
                  height: '284px',
                  flexGrow: 1,
                  flexBasis: 0,
                  borderRadius: 2,
                  p: 2,
                  boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <DonutCard
                  title={item.title}
                  data={Object.entries(item?.data ?? {}).map(([name, value]) => ({ name, value }))}
                  colors={item.colors}
                  chartHeight={180}
                />
              </Paper>
            </Grid>

            {/* 2. First Table Card */}
            <Grid item xs={12} sm={6} md={4}>
              <DashboardListTable
                data={Object.entries(item?.data ?? {})
                  .map(([name, value]) => {
                    const cleanedName = name.replace(/client/gi, '').trim();
                    const formattedName = cleanedName
                      ? cleanedName.charAt(0).toUpperCase() + cleanedName.slice(1).toLowerCase()
                      : cleanedName;
                    return { name: formattedName, value };
                  })
                  .sort((a, b) => a.name.localeCompare(b.name))}
                metric={metric}
              />
            </Grid>

            {/* 3. Second Table Card */}
            <Grid item xs={12} sm={6} md={4}>
              <AverageGradeCard data={item?.data ?? {}} />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>

      {/* Pending at Bar Chart */}
      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
              borderRadius: 2,
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
            }}
          >
            <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 600, mb: 1 }}>
              Rating
            </Typography>
            <PendingAtBarChart data={barChartData} height={250} baseLabels={workFlowLabels} />
          </Paper>
        </Grid>
      </Grid>
      {/* Table Row */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, borderRadius: 3 }}>
            {/* <KpiMetricsTable FilterKpiMetric={metric} dashboardKpiGridData={[]} FilterNeeded={false} /> */}
            <KpiMetricsTable
              FilterKpiMetric={metric}
              dashboardKpiGridData={data_table}
              FilterNeeded={false}
              isLoading={Boolean(loadings?.dashboardKpiGrid)}
              onDownloadXlsx={onDownloadXlsx}
              showDownload={showDownload}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default KpiMetricsPerformance;
